import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import SupportTemplateUpdateModalUI from './SupportTemplateUpdateModalUI.js'

class SupportTemplateUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      supportTemplateId: null,
      title: '',
      titleError: null,
      body: '',
      bodyError: null,
      message: '',
      messageError: null,
      submitted: false,
      parentTemplate: '',
      parentTemplateError: null,
      parentTemplateList: [],

    }
  }

  render() {
    return (
      <SupportTemplateUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // title
        title={this.state.title}
        onTitleChange={(event) => { this.setState({ title: event.target.value }) }}
        titleError={this.state.titleError}
        setTitleError={(error) => { this.setState({ titleError: error }) }}
        // body
        body={this.state.body}
        onBodyChange={(event) => { this.setState({ body: event.target.value }) }}
        bodyError={this.state.bodyError}
        setBodyError={(error) => { this.setState({ bodyError: error }) }}
        // message
        message={this.state.message}
        onMessageChange={(event) => { this.setState({ message: event.target.value }) }}
        messageError={this.state.messageError}
        setMessageError={(error) => { this.setState({ messageError: error }) }}
        // parentTemplate
        parentTemplate={this.state.parentTemplate}
        onparentTemplateChange={this.onparentTemplateChange}
        parentTemplateError={this.state.parentTemplateError}
        setparentTemplateError={(error) => { this.setState({ parentTemplateError: error }) }}
        parentTemplateList={this.state.parentTemplateList}
        parentList={this.props.templateList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        onMoveUpMode={this.state.onMoveUpMode}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!this.props.selectedTemplate)
      return
    if (!prevProps.selectedTemplate || prevProps.selectedTemplate.supportTemplateId !== this.props.selectedTemplate.supportTemplateId) {
      this.setState({
        supportTemplateId: this.props.selectedTemplate.supportTemplateId,
        title: this.props.selectedTemplate.title,
        body: this.props.selectedTemplate.body,
        message: this.props.selectedTemplate.message,
        parentTemplate: this.props.selectedTemplate.parentTemplateId,
        errorList: null,
        submitted: false
      })
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/support/templates/${this.state.supportTemplateId}`,
      this.onSubmitCallback, {
      title: this.state.title,
      body: this.state.body,
      message: this.state.message,
      parentTemplate: this.state.parentTemplate,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'title':
          this.setState({ titleError: error.message })
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    // window.scrollTo({top: 0, left: 0, behavior: 'smooth'})

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 600)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }
}

export default withRouter(SupportTemplateUpdateModalSF)
